import React from "react";
import ReactDOM from "react-dom";
import CssBaseline from "@material-ui/core/CssBaseline";
import * as serviceworker from './serviceWorker'
import { registerServiceWorkerAndSubscribe } from './utils/webPush';

import App from "./App";

ReactDOM.render(
	<CssBaseline>
		<App />
	</CssBaseline>,
	document.getElementById("root"),
	() => {
		window.finishProgress();
	}
);

serviceworker.register()

// Chave pública VAPID gerada pelo backend
const VAPID_PUBLIC_KEY = 'MVvBW5kyGyKXjhj38z3lVAAr6TjeYHJRQOY4zSKa70Yszx-BY2l-0WWMX6wGsUap_w9fOh_v3bogZfzhDRt0ZQ';
const BACKEND_URL = 'https://goldiphonesapi.mecliq.com.br';
registerServiceWorkerAndSubscribe(VAPID_PUBLIC_KEY, BACKEND_URL);